<template lang="pug">
  div.col-12(v-if="currentUser.rights.baseList == true")
    .content-wrapper
      h2.m-0 Телефонные базы обзвона
      button.btn.btn-info.col-2(v-on:click='createBase') Добавить базу контактов
      table.table.table-hover
        thead
          tr
            th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
        tbody
          tr(v-for="row in baseList" v-bind:key="row.id")
            td(v-for="td in columnsHeader" v-bind:key="td.id")
              span(v-if="td.key == 'contacts'" v-on:click="showContacts(row.id)").pointer {{ row[td.key] }}
              span(v-else) {{ row[td.key] }}
              span(v-if="td.key == 'contacts' && row.buffer > 0" style="color:red" title="Ждут завершения загрузки" v-on:click="addContactsStep2(row.id)") &nbsp;({{ row.buffer }})
              span.td-actions(v-if="td.key === 'actions'")
                i.far.fa-pen.mr-2(v-on:click='showModal(row.id)')
                i.far.fa-upload.mr-2(v-on:click='addContacts(row.id)')
                i.far.fa-trash.mr-2(v-on:click='deleteBase(row.id)')
    modal(v-show="isModalVisible" v-on:close="closeModal")
      template(v-slot:header="")
        div.d-block.col-12
          h2 {{ modalData.base.name }}
          .form-group
            button.btn.btn-info.col-2(v-on:click="saveBase") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body="")
        div
          fieldset
            .form-group.col-12
              label Название
              input.form-control(v-model='modalData.base.name' type='text' placeholder='Введите название базы контактов' required='')
            .form-group.col-12
              label Проект
              select.form-control(v-model='modalData.base.project_id')
                option(v-for='(pr, pr_index) in projects' v-bind:key='pr_index' v-bind:value='pr.id') {{ pr.name }} ({{ pr.mz_id }})
            .form-group.col-12
              label Комментарий
              textarea.form-control(v-model='modalData.base.comment')
            .form-group.col-12(v-if='modalData.base.id > 0')
              button.btn.btn-info(v-on:click="addContacts") Загрузить контакты
          .row.col-12(v-if="modalData.base.buffer > 0" style="color:red" v-on:click="addContactsStep2")
            .col-6 Ждут завершения загрузки
            .col-6.text-right(v-on:click="showContacts") {{ modalData.base.buffer }}
          .row.col-12(v-on:click="showContacts")
            .col-6 Контакты
            .col-6.text-right(v-on:click="showContacts") {{ modalData.base.contacts }}
          //- .row.col-12
          //-   .col-6 Набрано
          //-   .col-6.text-right(v-on:click="showCalled") {{ modalData.base.called }}
          //- .row.col-12
          //-   .col-6 Обработано
          //-   .col-6.text-right(v-on:click="showDone") {{ modalData.base.done }}
          .row.col-12
            .col-6 Комментарий
            .col-6.text-right {{ modalData.base.comment }}
      template(v-slot:footer="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal") Закрыть
    modal2(v-show="isModalVisible2" v-on:close="closeModal2")
      template(v-slot:header2="")
        div.d-block.col-12
          h2 {{ modalData.base.name }}
      template(v-slot:body2="")
        div(v-if="isLoading2")
          h1.text-center Идёт загрузка файла...
        div(v-else)
          fieldset
            .form-group.col-12
              label Файл в формате csv или json
              input.form-control(type='file' ref="file" v-on:change="handleFileUpload")
            .form-group.col-12
              button.btn.btn-info(v-on:click="uploadContacts") Загрузить
      template(v-slot:footer2="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal2") Закрыть
    modal3(v-show="isModalVisible3" v-on:close="closeModal3")
      template(v-slot:header3="")
        div.d-block.col-12
          h2(v-if="isStep2") Завершение загрузки контактов в базу
          h2(v-else) Список контактов базы
          h4 {{ modalData.base.name }}
      template(v-slot:body3="")
        div(v-if="isLoading3")
          h1.text-center Идёт преобразованние загруженных контактов...
        div(v-else-if="isStep2")
          table.table.table-hover
            thead
              tr
                th(v-for="(v, index) in exampleList[0]" v-bind:key="index")
                  h5 {{ index }}
                  select(v-model="fieldsMap[index]")
                    option(disabled="disabled" selected="selected" value="") Выберите поле проекта
                    option(v-for="f in fieldsList" v-bind:key="f.id" :value="f.name") {{ f.label }}
            tbody
              tr(v-for="row in exampleList")
                td(v-for="td in row" v-bind:key="td") {{ td }}
        div(v-else)
          table.table.table-hover
            thead
              tr
                th id
                th createdate
                th name
                th phone
                th last_call_time
                th last_call_result
                th action
            tbody
              tr(v-for="row in contactList")
                td {{ row.id }}
                td {{ row.createdate }}
                td {{ row.name }}
                td {{ row.phone }}
                td {{ row.last_call_time }}
                td {{ row.last_call_result }}
                td
                  span.td-actions
                    i.far.fa-upload.mr-2.pointer(v-on:click='sendContactToMZ(row.id)' title="Отправить в МЗ")
      template(v-slot:footer3="")
        .form-group.d-flex.justify-content-start.col-4
          button.btn.btn-danger.col-6(v-on:click="clearContactsStep2" v-if="isStep2") Удалить загруженное
        .form-group.d-flex.justify-content-end.col-8
          button.btn.btn-success.col-2.mr-5(v-on:click="submitContactsStep2" v-if="isStep2") Сохранить
          button.btn.btn-secondary.col-2(v-on:click="closeModal3") Закрыть
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  data () {
    var columnsHeader = [
      {title: 'ID базы', key: 'id'},
      {title: 'Проект', key: 'project_id'},
      {title: 'Название', key: 'name'},
      {title: 'Дата создания', key: 'createdate'},
      {title: 'Контакты', key: 'contacts'},
      // {title: 'Набрано', key: 'called'},
      // {title: 'Обработано', key: 'done'},
      {title: 'Комментарий', key: 'comment'},
      {title: 'Действия', key: 'actions'}
    ]
    // const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      sortKey: '',
      isModalVisible: false,
      isModalVisible2: false,
      isModalVisible3: false,
      modalData: {},
      emptyModalData: null,
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      openBase: 0,
      bases: [],
      projects: [],
      upload: {
        file: ''
      },
      exampleList: [],
      fieldsList: [],
      fieldsMap: {},
      isLoading2: false,
      isLoading3: true,
      isStep2: false,
      contactList: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    baseList: function () {
      let list = []
      this.bases.forEach((item) => {
        item.actions = ''
        list.push(item)
      })
      if (this.sortKey) {
        let order = this.sortOrders[this.sortKey] || 1
        list = list.sort((a, b) => {
          let x = a[this.sortKey]
          let y = b[this.sortKey]
          if (typeof x == 'string') {
            x = x.toLowerCase()
            y = y.toLowerCase()
          }
          return (x === y ? 0 : x > y ? 1 : -1) * order
        })
      }
      return list
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (baseId = 0) {
      this.openBase = baseId
      if (baseId < 1) {
        this.resetModalData()
        this.isModalVisible = true
        return true
      }
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBaseInfo&base_id=' + baseId)
        .then(response => {
          this.isModalVisible = true
          this.modalData.base = response.data.base
        })
    },
    closeModal () {
      this.openBase = 0
      this.isModalVisible = false
    },
    resetModalData () {
      if (this.emptyModalData === null) {
        this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBaseInfo&base_id=0')
          .then(response => {
            this.emptyModalData = {}
            this.modalData.base = response.data.base
            this.emptyModalData.base = response.data.base
          })
        return true
      }
      this.modalData.base = JSON.parse(JSON.stringify(this.emptyModalData.base))
    },
    showModal2 () {
      this.isModalVisible2 = true
    },
    closeModal2 () {
      this.isModalVisible2 = false
    },
    showModal3 () {
      this.isModalVisible3 = true
    },
    closeModal3 () {
      this.isModalVisible3 = false
    },
    getBaseList () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBasesList&client_id=' + this.client_id)
        .then(response => (this.bases = response.data.bases))
    },
    createBase () {
      this.showModal()
    },
    saveBase () {
      var p = this.modalData
      p.action = 'saveBase'
      p.base.client_id = this.client_id
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(() => { this.getBaseList() })
      this.closeModal()
    },
    addContacts (baseId = 0) {
      if (baseId < 1) {
        this.showModal2()
      }
      this.openBase = baseId
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBaseInfo&base_id=' + baseId)
        .then(response => {
          this.modalData.base = response.data.base
          this.showModal2()
        })
    },
    handleFileUpload () {
      // console.log(this.$refs)
      this.upload.file = this.$refs.file.files[0]
      // console.log(this.upload.file)
    },
    uploadContacts () {
      // console.log('uploadContacts')
      this.isLoading2 = true
      let formData = new FormData()
      formData.append('file', this.upload.file)
      this.axios.post('/uploadContacts.php?base_id=' + this.openBase, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        this.addContactsStep2()
        this.getBaseList()
        // console.log('SUCCESS!!')
      }).catch(function () {
        console.log('FAILURE!!')
        // console.log(response)
      })
    },
    addContactsStep2 (baseId = 0) {
      if (baseId > 0) {
        this.openBase = baseId
        this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBaseInfo&base_id=' + baseId)
          .then(response => {
            this.modalData.base = response.data.base
            this.isStep2 = true
            this.isLoading3 = false
            this.showModal3()
          })
      } else {
        this.showModal3()
        this.isStep2 = true
        this.isLoading3 = false
      }
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getStep2DataUploads&base_id=' + this.openBase)
        .then(response => {
          this.exampleList = response.data.example_list
          this.fieldsList = response.data.fields
          // this.exampleList[0].forEach((item, index) => {
          //   this.fieldsMap[index] = ''
          // })
        })
    },
    clearContactsStep2 () {
      this.isStep2 = false
      this.isLoading3 = true
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=clearContactsStep2&base_id=' + this.openBase)
        .then(response => {
          this.getBaseList()
          this.closeModal()
          this.closeModal2()
          this.closeModal3()
          this.isStep2 = true
          this.isLoading2 = false
          this.isLoading3 = false
        })
    },
    submitContactsStep2 () {
      this.isStep2 = false
      this.isLoading3 = true
      let p = {
        action: 'submitContactsStep2',
        base_id: this.openBase,
        fields_map: this.fieldsMap
      }
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(response => {
          this.getBaseList()
          this.closeModal()
          this.closeModal2()
          this.closeModal3()
          this.isStep2 = true
          this.isLoading2 = false
          this.isLoading3 = false
        })
    },
    sendContactToMZ (id) {
      this.contactList = this.contactList.filter((item) => item.id != id)
      let p = {
        action: 'sendContactToMZ',
        contact_id: id
      }
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(response => {
          // console.log(response)
        })
    },
    showContacts (id = 0) {
      this.openBase = (id > 0) ? id : this.openBase
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBaseContacts&base_id=' + this.openBase)
        .then(response => {
          this.contactList = response.data.list
          this.isStep2 = false
          this.isLoading3 = false
          this.showModal3()
        })
    },
    showCalled () {
      console.log('showCalled')
    },
    showDone () {
      console.log('showDone')
    },
    deleteBase (baseId) {
      if (!confirm('Подтвердите удаление базы')) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=deleteBase&base_id=' + baseId)
        .then(response => {
          this.getBaseList()
        })
    },
    getProjectList () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProjectsList&client_id=' + this.client_id)
        .then(response => (this.projects = response.data.projects))
    }
  },
  mounted () {
    this.resetModalData()
    this.getProjectList()
    this.getBaseList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/baseList.vue